import React, { useEffect, useState } from 'react'
import './All_Album_Chants.css'
import Common_Back_Header from '../common/common_components/common_back_header/Common_Back_Header'
import Music_card from '../common/common_components/music-card/Music_card'
import { AllChants } from '../../features/admin/common/Slice'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IDS } from '../../utils/IDS'
import { decodeId } from '../../utils/common'
import Music_play_modal from '../common/modals/music-play-modal/Music_play_modal' // ✅ import modal
const All_Album_Chants = () => {

    const { id } = useParams()
    const dispatch = useDispatch();
    const chantsAl = useSelector((state) => state.common.all_chants);

    // ✅ Modal state
    const [showModal, setShowModal] = useState(false);
    const [selectedMusic, setSelectedMusic] = useState(null);

    useEffect(() => {
        dispatch(AllChants({ chant_type_id: decodeId(id) }));
    }, [dispatch]);

    // ✅ Play all — start from first song
    const handlePlayAll = () => {
        if (chantsAl?.length > 0) {
            setSelectedMusic(chantsAl[0]);
            setShowModal(true);
        }
    };

    return (
        <>
            <section className='All_albums_sec All_Album_Chants'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />
                    <div className='banner_div'>
                        <img className='banner_img' src={IDS.IMG_URL + chantsAl[0]?.Chant_Type?.image} />
                    </div>

                    <div className='row'>
                        <div className='col-md-11 mx-auto'>
                            <div className='almb_sec'>
                                <div className='musix_box'>
                                    <div className='namediv'>
                                        <h6 className='name'>{chantsAl[0]?.Chant_Type?.name}</h6>
                                        <h6 className='name'>{chantsAl?.length || "0"} Chants</h6>
                                    </div>
                                    <div className='icondiv'>
                                        {/* ✅ Play all button */}
                                        <img
                                            className='playicon'
                                            src={process.env.PUBLIC_URL + '/assets/images/icons/play2.png'}
                                            alt="play-btn"
                                            style={{ cursor: "pointer" }}
                                            onClick={handlePlayAll}
                                        />
                                    </div>
                                </div>

                                <div className='all_albulms'>
                                    {chantsAl?.map((music, index) => (
                                        <div className='albm_div' key={index}>
                                            {/* ✅ Pass setSelectedMusic and setShowModal to each card */}
                                            <Music_card
                                                music={music}
                                                musicList={chantsAl}
                                                onPlay={(music) => {
                                                    setSelectedMusic(music);
                                                    setShowModal(true);
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ✅ Single modal instance */}
            {showModal && (
                <Music_play_modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    music={selectedMusic}
                    musicList={chantsAl}
                />
            )}
        </>
    );
};

export default All_Album_Chants;